import {useMediaQuery} from 'react-responsive'

export const MOBILE_MAX_WIDTH = 700
export const MOBILE_MEDIA_QUERY = `(max-width: ${MOBILE_MAX_WIDTH}px)`

export const useIsMobile = () => {
  return useMediaQuery({query: MOBILE_MEDIA_QUERY})
}
